import React, { useEffect, useState } from "react";
import PageHeading from "../common/PageHeading";
import { BellIcon, ThumbsUp, VideoButton } from "../../utils/SvgComponents";
import { ChevronDown } from "lucide-react";
import CustomButton from "../common/button/Button";
import RippleInitializer from "../new-pages/RippleInitializer";
import { useParams } from "react-router-dom";
import { apiHandler } from "../../utils/apiHandler";
import { EVENT_BASEURL } from "../../utils/Constants";
import { motion } from "framer-motion";

const LiveWedding = () => {
	const { id } = useParams()
	const [response, setResponse] = useState([]);
	const [comment, setComment] = useState([]);
	const [isSticky, setIsSticky] = useState(false);
	const [isVideoPlaying, setIsVideoPlaying] = useState(false);
	const [isMobileVideoPlaying, setIsMobileVideoPlaying] = useState(false);
	const [visibleCount, setVisibleCount] = useState(0);
	const [isImageLoaded, setIsImageLoaded] = useState(false);
	let animationFrameId = null;
	let NewUsername = "";

	const pathArray = window.location.pathname.split("/").filter(Boolean);

	if (pathArray.includes("Login")) {
		// Handle special case when URL contains "Login"
		NewUsername = pathArray[1];
	} else {
		NewUsername = pathArray[0]
	}

	let data = JSON.parse(localStorage.getItem(`logindata_${NewUsername}`))
	const newImgUrl = `https://welcometowedding.com/events/${data?._id}/`
	console.log(newImgUrl);
	useEffect(() => {
		const fetchDashBoard = async () => {
			try {

				const res = await apiHandler.post("/guest/fetch-feature", {
					_id: id,
					category: "LiveWedding"
				});
				console.log(res);
				if (res) {
					console.log(res.functions)
					setResponse(res);
					setComment(res.comments)

				}
			} catch (err) {
				console.error("Guest login error:", err);
			}
		};

		fetchDashBoard();
	}, [])


	useEffect(() => {
		const handleScroll = () => {
			if (animationFrameId) {
				cancelAnimationFrame(animationFrameId);
			}
			animationFrameId = requestAnimationFrame(() => {
				const outerElement = document.querySelector('.scroll-bar');
				if (outerElement) {
					const scrollPosition = outerElement.scrollTop;
					setIsSticky(scrollPosition > 0);
				}
			});
		};

		const outerElement = document.querySelector('.scroll-bar');
		if (outerElement) {
			outerElement.addEventListener('scroll', handleScroll);
			handleScroll(); // Initial check

			return () => {
				outerElement.removeEventListener('scroll', handleScroll);
				if (animationFrameId) {
					cancelAnimationFrame(animationFrameId);
				}
			};
		}
	}, []);


	useEffect(() => {
		if (!comment || comment.length === 0) return;

		let index = 0;

		const interval = setInterval(() => {
			index++;
			setVisibleCount(index);
			if (index >= comment.length) {
				clearInterval(interval);
			}
		}, 200); // 400ms delay between each

		return () => clearInterval(interval);
	}, [comment]);

	function formatDateTime(dateTimeString) {
		const date = new Date(dateTimeString);

		const formattedDate = date.toLocaleDateString("en-IN", {
			day: "2-digit",
			month: "long",
		});

		const formattedTime = date.toLocaleTimeString("en-IN", {
			hour: "2-digit",
			minute: "2-digit",
			hour12: true,
		});

		return {
			date: formattedDate,
			time: formattedTime,
		};
	}

	const containerVariants = {
		hidden: {},
		show: {
			transition: {
				staggerChildren: 0.2,
			},
		},
	};

	const itemVariants = {
		hidden: { opacity: 0, y: 30 },
		show: { opacity: 1, y: 0, transition: { duration: 0.5, ease: "easeOut" } },
	};

	const bgUrl = (!isVideoPlaying || !isMobileVideoPlaying) && response?.basicDetails?.liveWeddingBg
		? `${newImgUrl}${response.basicDetails.liveWeddingBg}`
		: null;

	// Preload the image and update state when loaded
	useEffect(() => {
		if (!bgUrl) return;
		const img = new Image();
		img.src = bgUrl;
		img.onload = () => setIsImageLoaded(true);
	}, [bgUrl]);
	console.log(`https://www.youtube.com/embed/${response?.basicDetails?.ybLink}`)
	return (
		<div style={{ zIndex: '333333', backgroundColor: 'white' }}>
			<div className="hidden sm:block h-screen">
				<div className="grid grid-cols-12 h-full">
					<div className="col-span-5 bg-black h-full  text-white flex flex-col gap-7 items-center overflow-x-auto scroll-bar">
						<div className={`m-0 py-2 w-full w-full stickynav ${isSticky ? "isSticky" : "hideinmobile"}`} style={{ position: 'sticky', top: 0, zIndex: '1', backgroundColor: 'black', textAlign: 'center' }}>
							<PageHeading title="Live Wedding" color={true} style={{ position: 'fixed' }} />
						</div>
						<div className="flex flex-col gap-[30px] px-[30px] pt-1 pb-4 ">
							{(!comment || comment.length === 0) && (
								<div className="bg-white p-[20px] rounded-xl flex gap-2 justify-between items-start whiteripple cursor-pointer">
									No comments yet
								</div>
							)}

							<motion.div
								className="flex flex-col gap-[30px]  pt-1 pb-4"
								variants={containerVariants}
								initial="hidden"
								animate="show"
							>

								{comment && comment.slice(0, visibleCount).map((item, index) => (
									<motion.div
										key={index}
										variants={itemVariants}
										className="bg-white p-[20px] rounded-xl flex gap-2  items-start whiteripple cursor-pointer"
									>
										<div className="bg-green-800 px-3 py-2 rounded-full text-[18px]">
											{item.username[0]}
										</div>
										<div className="text-black w-100">
											<div className="flex justify-between items-center mb-2">
												<div className="font-semibold text-[18px]">
													@{item.username}
												</div>
												<div className="flex gap-2 items-center">
													<ThumbsUp width="24" /> {item.likes}
												</div>
											</div>
											<div className="text-[17px]">
												{item.comment}
											</div>
										</div>
									</motion.div>
								))}
							</motion.div>
						</div>

					</div>
					<div className="col-span-7 p-[25px] h-screen overflow-x-auto scroll-bar" onClick={() => {
						console.log("clicked")
						if (response?.basicDetails?.ybLink) {
							setIsVideoPlaying(true)
						}
					}} >
						<motion.div
							initial={{ opacity: 0, y: 30, filter: "blur(20px)" }}
							animate={{
								opacity: 1,
								y: 0,
								filter: isImageLoaded ? "blur(0px)" : "blur(20px)",
							}}
							transition={{ duration: 0.8, ease: "easeOut" }}
							className="h-[60%] bg-center bg-cover bg-no-repeat flex relative cursor-pointer whiteripple"
							style={{
								backgroundImage: bgUrl ? `url(${bgUrl})` : "none",
							}}
						>


							{!isVideoPlaying ? (
								<>
									<div className="absolute top-0 bottom-0 left-0 right-0 grid place-items-center whiteripple"  >
										<RippleInitializer />
										<div className="rounded-full border-radius whiteripple">
											<RippleInitializer />
											<button >
												<RippleInitializer />
												<div className="bg-black/50 rounded-full p-1 whiteripple">
													<VideoButton width="50" height="50" fill="white" />
												</div>
											</button>
										</div>
									</div>

									<div className="flex items-end p-3 w-full">
										<div className="px-3 py-2 bg-black/70 text-white buttonripple">
											<div className="text-[16px]">
												Premieres on {response && formatDateTime(response?.basicDetails?.dateTime).date}
											</div>
											<div className="text-[14px]">
												Estimated Time {response && formatDateTime(response?.basicDetails?.dateTime).time}
											</div>
										</div>
									</div>
								</>
							) : (
								response?.basicDetails?.ybLink && <iframe
									src={`https://www.youtube.com/embed/${response?.basicDetails?.ybLink}?autoplay=1&rel=0&modestbranding=1&controls=1`}
									title="Live Wedding Video"
									className="w-full h-full rounded-xl"
									referrerpolicy="strict-origin-when-cross-origin"
									allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
									allowFullScreen
								/>
							)}
							{/* <div className="absolute top-[3%] left-[3%] bg-white rounded-full">
                                <BackArrowIcon width="35" height="35" />
                            </div> */}
						</motion.div>
						<div className="flex mt-3 mx-[5px] items-center gap-4">
							<div className="bg-[#fe0000] p-2 rounded-full"></div>
							<div className="font-semibold text-[28px]">
								{response && response?.basicDetails?.weddingTitle}
							</div>
						</div>
						<div className="mx-[5px] text-[18px] font-semibold">
							Family Waiting{" "}
							{response && response?.basicDetails?.hashtags.split(" ").map((tag, index) => (
								<span key={index} className="text-[#055fd6]">
									{tag}{" "}
								</span>
							))}
						</div>
						<div className="mx-[5px] flex justify-between items-center my-3">
							<div className="flex gap-[14px] items-center">
								<div className="w-[50px] h-[50px] rounded-[100%] overflow-hidden">
									{/* <img src={videoIcon} className="" alt="" /> */}
								</div>
								<div className="font-semibold text-[18px]">
									{response && response?.basicDetails?.channelName}
								</div>
							</div>
							<div className="flex gap-2 ps-2 pe-4 py-2 bg-[#eaeaea] rounded-full">
								<div>
									<BellIcon />
								</div>
								<span className="text-[16px] font-medium">
									Subscribed
								</span>
								{/* <span>
                                    <ChevronDown />
                                </span> */}
							</div>
						</div>
						<div className="mx-[5px] bg-[#eaeaea] text-[17px] leading-6 p-[20px] rounded-lg text-justify black-color">

							<p className="mb-4">
								{response &&
									response?.basicDetails?.description
										.split("\n")
										.map((para, idx) => {
											if (para.includes(" - ")) {
												const [label, url] = para.split(" - ");

												// Display text with www + dashes instead of dots
												const displayUrl = "www." + url.replace(/\./g, ".");

												return (
													<span key={idx}>
														{label} -{" "}
														<a
															href={`https://${url}`}
															target="_blank"
															rel="noopener noreferrer"
															className="text-blue-500 underline"
														>
															{displayUrl}
														</a>
														<br />
													</span>
												);
											} else {
												return (
													<span key={idx}>
														{para}
														<br />
													</span>
												);
											}
										})}
							</p>


						</div>
					</div>
				</div>
			</div>
			<div className="block sm:hidden overflow-y-auto h-dvh">
				<div className="bg-[#212121]">
					{/* Video Container with fixed aspect ratio */}
					<div className="relative w-full" style={{ paddingTop: "56.25%" }}> {/* 16:9 ratio */}
						{!isMobileVideoPlaying ? (
							<>
								{response?.basicDetails?.liveWeddingBg && <img
									src={newImgUrl + response?.basicDetails?.liveWeddingBg}
									onLoad={() => setIsImageLoaded(true)}
									alt=""
									className={`absolute top-0 left-0 w-full h-full object-cover transition-all duration-500 ${!isImageLoaded ? "blur-lg scale-105" : "blur-0 scale-100"
										}`}
								/>}

								{/* Play button overlay */}
								<div
									className="absolute top-0 left-0 right-0 bottom-0 grid place-items-center"
									onClick={() => setIsMobileVideoPlaying(true)}
								>
									<div className="rounded-full overflow-hidden">
										<button>
											<div className="bg-black/50 rounded-full p-[3px]">
												<VideoButton width="50" height="50" fill="white" />
											</div>
										</button>
									</div>
								</div>
							</>
						) : (
							response?.basicDetails?.ybLink && (
								<iframe
									src={`https://www.youtube.com/embed/${response?.basicDetails?.ybLink}?autoplay=1&rel=0&modestbranding=1&controls=1`}
									title="Live Wedding Video"
									className="absolute top-0 left-0 w-full h-full rounded-xl"
									referrerPolicy="strict-origin-when-cross-origin"
									allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
									allowFullScreen
								/>
							)
						)}
					</div>

					{/* Event info */}
					<div className="py-[10px] ps-[15px] h-full">
						<div className="flex items-center gap-2">
							<div className="bg-[#fe0000] p-[6px] rounded-full"></div>
							<div className="font-semibold text-white">
								{response?.basicDetails?.weddingTitle}
							</div>
						</div>
						<div className="text-white pt-1">
							Family Waiting{" "}
							{response?.basicDetails?.hashtags.split(" ").map((tag, index) => (
								<span key={index} className="text-[#2196f3] font-medium">
									{tag}{" "}
								</span>
							))}
						</div>
					</div>

					{/* Channel info */}
					<div className="flex justify-between items-center py-[10px] px-[15px] border-b border-t border-neutral-700">
						<div className="flex gap-2 items-center">
							<div className="w-8 h-8 rounded-[100%] border-2">
								{/* <img src={videoIcon} alt="" /> */}
							</div>
							<div className="font-medium text-white">
								{response?.basicDetails?.channelName}
							</div>
						</div>
						<div className="text-[14px] font-medium text-white uppercase">
							Subscribed
						</div>
					</div>

					{/* Description */}
					<div className="text-justify text-white py-[10px] px-[15px] text-[15px] leading-5">
						{response?.basicDetails?.description.split("\n").map((para, idx) => (
							<React.Fragment key={idx}>
								{para} <br />
							</React.Fragment>
						))}
					</div>
				</div>
			</div>

		</div>
	);
};

export default LiveWedding;
